import { DvDialogOptions } from '@devinco/ui/dds';
import { FileUploadDialogComponent } from './file-upload-dialog.component';
import { FileUploadModalData as FileUploadDialogData } from './interfaces';

export const fileUploadModalConfig = (
  data: FileUploadDialogData
): DvDialogOptions<FileUploadDialogData, FileUploadDialogComponent> => {
  return {
    hideFooter: true,
    size: 'xl',
    title: 'FileUploadModal.Title',
    confirmText: 'General.Add',
    cancelText: 'General.Cancel',
    contentComponent: FileUploadDialogComponent,
    data,
  };
};
